import { TFunction } from "i18next";
import * as yup from "yup";

export interface Name {
  familyName: string;
  givenName: string;
  middleName: string;
  prefix: string;
  suffix: string;
}

export const NameValidation = (t: TFunction) =>
  yup.object({
    familyName: yup
      .string()
      .required(t("validation.name.familyName.required"))
      .max(64, t("validation.name.familyName.max", { max: 64 }))
      .min(2, t("validation.name.familyName.min", { min: 2 })),
    givenName: yup.string().max(64),
    middleName: yup.string().max(64),
    prefix: yup.string().max(64),
    suffix: yup.string().max(64),
  });

export const createName = (
  familyName: string = "",
  givenName: string = "",
  middleName: string = "",
  prefix: string = "",
  suffix: string = ""
): Name => ({
  familyName: familyName,
  givenName: givenName,
  middleName: middleName,
  prefix: prefix,
  suffix: suffix,
});

export const formatName = (name: Name | undefined) => {
  let result: string = "";
  if (!name)
    return result;
  if (name.prefix.length > 0) {
    result += name.prefix + " ";
  }
  if (name.givenName.length > 0) {
    result += name.givenName + " ";
  }
  if (name.middleName.length > 0) {
    result += name.middleName + " ";
  }
  if (name.familyName.length > 0) {
    result += name.familyName + " ";
  }
  if (name.suffix.length > 0) {
    result += ", " + name.suffix + " ";
  }
  return result.trim();
};

/**
 * Compare names by components.
 * @param lhs Left name.
 * @param rhs Right name.
 * @returns True, if names are equal, false otherwise.
 */
export const isNameEqual = (
  lhs: Name | undefined,
  rhs: Name | undefined
): boolean => {
  return (
    (lhs !== undefined &&
      rhs !== undefined &&
      lhs.familyName === rhs.familyName &&
      lhs.givenName === rhs.givenName &&
      lhs.middleName === rhs.middleName &&
      lhs.prefix === rhs.prefix &&
      lhs.suffix === rhs.suffix) ||
    lhs === rhs
  );
};
